import script from "./template-switch.vue?vue&type=script&lang=js"
export * from "./template-switch.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__